import { render, staticRenderFns } from "./unitoffers.vue?vue&type=template&id=f046bd06&"
import script from "./unitoffers.vue?vue&type=script&lang=js&"
export * from "./unitoffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f046bd06')) {
      api.createRecord('f046bd06', component.options)
    } else {
      api.reload('f046bd06', component.options)
    }
    module.hot.accept("./unitoffers.vue?vue&type=template&id=f046bd06&", function () {
      api.rerender('f046bd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8JzuhB2N9G6vH/JS/unitoffers.vue"
export default component.exports